export default "__VITE_ASSET__88EEIbY9__"